<template>
  <v-container class="mt-2" v-if="!loading">
    <v-card
      class="px-2 pb-6">
      <v-row>
        <v-col cols="9">
          <p>Coberturas - Listar</p>
        </v-col>
        <v-col cols="3" class="d-flex flex-row justify-end">
          <v-btn class="mr-1" small @click="edit" v-if="selected.length == 1">
            <v-icon small title="Editar">fas fa-edit</v-icon>
          </v-btn>
          <v-btn class="mr-1" small v-if="selected.length" @click="removeAll">
            <v-icon small title="Remover Selecionados">fas fa-trash</v-icon>
          </v-btn>
          <v-btn class="mr-1" small @click="create">
            <v-icon small title="Criar">fas fa-plus</v-icon>
          </v-btn>
          <v-btn small @click="findAll(true)">
            <v-icon small title="Buscar">fas fa-search</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="mb-4"></v-divider>

      <CoverageForm ref="form" :typeForm="'search'" :errors="errors" :coverage="coverage" :isListView="true"></CoverageForm>

      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-data-table
              v-model="selected"
              :headers="headers"
              :options.sync="options"
              :items="items"
              item-key="id"
              locale="pt-BR"
              show-select
              class="elevation-1 mt-3 row-pointer"
              hide-default-footer
              @click:row="show"
            >
              <template v-slot:[`item.ansCoverage`]="{ item }">
                <span> {{ (!item.ansCoverage || item.ansCoverage === 'false') ? 'Não' : 'Sim' }} </span>
              </template>
              <template v-slot:[`item.executiveDifferential`]="{ item }">
                <span> {{ (!item.executiveDifferential || item.executiveDifferential === 'false') ? 'Não' : 'Sim' }} </span>
              </template>
            </v-data-table>
          </v-col>

          <v-col cols="12" v-if="itemsTotal">
            <v-pagination
              v-model="optionsAux.page"
              :length="itemsTotal"
              :total-visible="10"
              @input="findAll()"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <DlgConfirmCancel ref="confirm"></DlgConfirmCancel>
  </v-container>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import DlgConfirmCancel from '@/components/dlg-confirm_cancel.vue';
import CoverageForm from "@/components/coverage/coverage_form"
import XippAuthService from "@/services/auth/XippAuthService";

export default {
  components: {DlgConfirmCancel, CoverageForm},
  data() {
    return {
      coverage: {
        name: null,
        recordType: null,
        is_ans_coverage: false,
        is_executive_differential: false,
        allAnsExecutiveDifferential: false,
        rule: null,
      },
      headers: [
        {text: 'Nome', align: 'start', value: 'name', sortable: true },
        {text: 'Tipo de Registro', align: 'start', value: 'recordType', sortable: true},
        {text: 'Cobertura ANS', align: 'center', value: 'ansCoverage', sortable: true},
        {text: 'Diferencial Executivo', align: 'center', value: 'executiveDifferential', sortable: true},
        {text: 'Regras', align: 'center', value: 'rule', sortable: true},
      ],
      options: {},
      optionsAux: {
        page: 1,
        size: 10
      },
      items: [],
      itemsTotal: null,
      singleSelect: false,
      selected: [],
      errors: {},
      loading: true,
    };
  },
  beforeCreate() {
    this._xippAuthService = new XippAuthService();
  },
  async created() {
    const sessionKey = "access_token";
    
    const {token} = this.$route.query;
    if (token) {
      try {
        localStorage.setItem('tiny_token', this.$route.query.token);
        localStorage.setItem(sessionKey, this.$route.query.token);
        this.toogleDialogLoading(this.loading);
        await this._xippAuthService.GetTokenFull()
          .then((response) => {
            if(response && response.data) {
              localStorage.setItem(sessionKey, response.data.token);
            }
          })
          .finally(() => {
            this.loading = false;
            this.toogleDialogLoading(this.loading);
          });
      } catch (e) {
        this.loading = false;
        this.toogleDialogLoading(this.loading);
        console.log(e)
      }
    }
  },
  computed: {
    ...mapGetters("coverage", [ "coverageProcessed", "getCoverages" ]),
  },
  methods: {
    ...mapActions("coverage", ["deleteCoverage", "fetchCoverages"]),
    ...mapMutations(['toogleDialogLoading']),
    findAll(searching = null) {
      const {sortBy, sortDesc} = this.options;
      this.toogleDialogLoading(true);
      
      if(searching) {
        this.optionsAux.page = 1;
      }

      this.coverage.ansCoverage = this.coverage.is_ans_coverage;
      this.coverage.executiveDifferential = this.coverage.is_executive_differential;

      this.fetchCoverages(
        Object.assign(this.coverage, {
          page: this.optionsAux.page - 1,
          sortBy: sortBy && sortBy.length ? sortBy[0] : 'code',
          descending: sortDesc && sortDesc.length ? sortDesc[0] : false,
          size: this.optionsAux.size,
        }),
      ).then((data) => {
        this.items = data.content;
        this.itemsTotal = data.totalPages;
      }).finally(() => {
        this.toogleDialogLoading(false);
      });
    },
    async removeAll() {
      this.toogleDialogLoading(true);
      if (
        this.selected.length && (await this.$refs.confirm.show('Atenção', 'Deseja excluir os registros selecionados?'))) {
        for (const coverage of this.selected) {
          await this.deleteCoverage(coverage.id);
        }
        this.selected=[];
        this.findAll();
      } else {
        this.toogleDialogLoading(false);
      }
    },
    edit() {
      this.$router.push(`/coverage/${this.selected[0].id}/edit`);
    },
    create() {
      this.$router.push('/coverage/new');
    },
    show(value) {
      this.$router.push(`/coverage/${value.id}/show`);
    },
  },
};
</script>

<style scoped>
.row-pointer:hover {
  cursor: pointer;
}

</style>
